module.exports = __webpack_public_path__ + "static/media/447620069_776346104308238_8924730797809640116_n.34fd61ae.jpg";